// import { useEffect, useRef, useState } from "react";

// const L = (...a) => console.log("[OURBIT FUTURES]", ...a);

// const DEFAULT_PROXY = null;
// const FUT_TICKERS_URL = "https://futures.ourbit.com/api/v1/contract/ticker";
// const FUT_DEPTH_STEP_URL = (sym, step) =>
//   `https://futures.ourbit.com/api/v1/contract/depth_step/${sym}?step=${step}`;

// // "ETHUSDT" | "ETH_USDT" | "eth-usdt" -> "ETH_USDT"
// function toOurbitFutSymbol(input) {
//   const s = String(input || "").toUpperCase().replace(/[-]/g, "_");
//   if (!s) return null;
//   if (/_USDT$/.test(s)) return s;
//   const m = s.match(/^([A-Z0-9]+)USDT$/);
//   if (m) return `${m[1]}_USDT`;
//   return `${s}_USDT`;
// }

// function decimalsOf(numLike) {
//   const s = String(numLike ?? "");
//   const i = s.indexOf(".");
//   return i === -1 ? 0 : (s.length - i - 1);
// }

// function stepFromLastPrice(lastPrice) {
//   const d = decimalsOf(lastPrice);
//   // пример из ТЗ: lastPrice 0.03892 -> step 0.00001 (5 знаков)
//   return d <= 0 ? "1" : `0.${"0".repeat(d - 1)}1`;
// }

// // поддержка форматов [[p,q],...] и [{p,q}] и [{price,vol}] и т.п.
// function normalizeSide(side) {
//   if (!Array.isArray(side)) return [];
//   if (side.length === 0) return [];
//   if (Array.isArray(side[0])) {
//     return side.map(([p, q]) => [String(p), String(q)]);
//   }
//   return side.map((row) => {
//     const p = row?.p ?? row?.price ?? row?.Price;
//     const q = row?.q ?? row?.volume ?? row?.qty ?? row?.Volume;
//     return [String(p), String(q)];
//   });
// }

// function normalizeDepth(payload) {
//   const data = payload?.data ?? payload?.result ?? payload;
//   const asks = normalizeSide(data?.asks ?? data?.Asks);
//   const bids = normalizeSide(data?.bids ?? data?.Bids);
//   return { asks, bids };
// }

// export function useOurbitFutures(symbol, {
//   pollIntervalMs = 1000,
//   proxy = DEFAULT_PROXY,
//   depthLimit = 50,
// } = {}) {
//   const [orderBook, setOrderBook]   = useState({ asks: [], bids: [] });
//   const [tickerData, setTickerData] = useState(null);
//   const [error, setError]           = useState(null);
//   const [isConnected, setIsConnected] = useState(false);

//   const timerRef = useRef(null);
//   const stepRef  = useRef(null); // держим найденный step

//   useEffect(() => {
//     const sym = toOurbitFutSymbol(symbol);
//     if (!sym) {
//       setOrderBook({ asks: [], bids: [] });
//       setTickerData(null);
//       setIsConnected(false);
//       setError(null);
//       stepRef.current = null;
//       return;
//     }

//     let cancelled = false;

//     const fetchTickersAndStep = async () => {
//       const url = proxy ? `${proxy}/${FUT_TICKERS_URL}` : FUT_TICKERS_URL;
//       const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
//       if (!r.ok) throw new Error(`Ourbit FUT tickers HTTP ${r.status}`);
//       const js = await r.json();
//       if (!js?.success) throw new Error(js?.message || "Tickers not ok");

//       const arr = Array.isArray(js?.data) ? js.data : [];
//       const row = arr.find((x) => String(x?.symbol).toUpperCase() === sym);
//       if (!row) throw new Error(`Ticker for ${sym} not found`);

//       const lp = row.lastPrice ?? row.last ?? row.price;
//       const step = stepFromLastPrice(lp);
//       stepRef.current = step;

//       setTickerData({ lastPrice: String(lp) });
//       return step;
//     };

//     const fetchDepthOnce = async () => {
//       // гарантируем наличие step
//       const step = stepRef.current || (await fetchTickersAndStep());
//       const url = FUT_DEPTH_STEP_URL(sym, step);
//       const finalUrl = proxy ? `${proxy}/${url}` : url;

//       L("fetch depth_step", { sym, step, url: finalUrl });
//       const res = await fetch(finalUrl, { headers: { 'ngrok-skip-browser-warning': '1' } });
//       if (!res.ok) throw new Error(`Ourbit FUT depth HTTP ${res.status}`);
//       const json = await res.json();

//       const { asks, bids } = normalizeDepth(json);
//       const A = depthLimit ? asks.slice(0, depthLimit) : asks;
//       const B = depthLimit ? bids.slice(0, depthLimit) : bids;

//       setOrderBook({ asks: A, bids: B });

//       // обновим bid/ask в тикере, если хотим
//       const a0 = A?.[0]?.[0] ? Number(A[0][0]) : null;
//       const b0 = B?.[0]?.[0] ? Number(B[0][0]) : null;
//       setTickerData((td) => ({
//         ...td,
//         ask: a0 != null ? String(a0) : td?.ask ?? null,
//         bid: b0 != null ? String(b0) : td?.bid ?? null,
//       }));

//       setError(null);
//       setIsConnected(true);
//     };

//     const start = async () => {
//       try {
//         // первая инициализация: определяем step и тянем стакан
//         await fetchTickersAndStep();
//         await fetchDepthOnce();
//       } catch (e) {
//         L("init error", e?.message || e);
//         setError(e?.message || String(e));
//         setIsConnected(false);
//       }
//       if (cancelled) return;

//       timerRef.current = setInterval(async () => {
//         try {
//           await fetchDepthOnce();
//         } catch (e) {
//           // если depth внезапно стал ругаться — перестроим step через тикеры
//           L("poll error", e?.message || e);
//           try {
//             await fetchTickersAndStep();
//           } catch (e2) {
//             L("re-ticker error", e2?.message || e2);
//           }
//           setIsConnected(false);
//           setError(e?.message || String(e));
//         }
//       }, pollIntervalMs);
//     };

//     start();

//     return () => {
//       cancelled = true;
//       if (timerRef.current) clearInterval(timerRef.current);
//       timerRef.current = null;
//       stepRef.current = null;
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [symbol, pollIntervalMs, proxy, depthLimit]);

//   return { isConnected, error, orderBook, tickerData };
// }

// export default useOurbitFutures;
import { useEffect, useRef, useState } from "react";

const L = (...a) => console.log("[OURBIT FUTURES]", ...a);

// ✅ дефолтно ходим через твой бек-прокси
const DEFAULT_PROXY = `${process.env.REACT_APP_BACKEND_URL || ""}/proxy`;

// Абсолютные URL к Ourbit
const FUT_TICKERS_URL = "https://futures.ourbit.com/api/v1/contract/ticker";
const FUT_DEPTH_STEP_URL = (sym, step) =>
  `https://futures.ourbit.com/api/v1/contract/depth_step/${encodeURIComponent(sym)}?step=${encodeURIComponent(step)}`;

// ✅ Умный конструктор прокси-URL, без двойного проксирования
function viaProxy(proxy, absUrl) {
  if (!proxy) return absUrl;
  const p = proxy.replace(/\/+$/,"");
  const a = String(absUrl);

  // Уже проксировано? Оставляем как есть.
  if (a.includes("/proxy/")) return a;

  // Если absUrl уже на том же хосте, что и proxy, и внутри есть /proxy — не трогаем
  try {
    const pURL = new URL(p);
    const aURL = new URL(a);
    if (aURL.host === pURL.host && aURL.pathname.includes("/proxy/")) return a;
  } catch {
    // ignore URL parse errors, just fall through
  }

  // К твоему прокси добавляем ПОЛНЫЙ абсолютный URL (со схемой)
  return `${p}/${a}`;
}

// "ETHUSDT" | "ETH_USDT" | "eth-usdt" -> "ETH_USDT"
function toOurbitFutSymbol(input) {
  const s = String(input || "").trim().toUpperCase().replace(/[-]/g, "_");
  if (!s) return null;
  if (/_USDT$/.test(s)) return s;
  const m = s.match(/^([A-Z0-9]+)USDT$/);
  if (m) return `${m[1]}_USDT`;
  return `${s}_USDT`;
}

function decimalsOf(numLike) {
  const s = String(numLike ?? "");
  const i = s.indexOf(".");
  return i === -1 ? 0 : (s.length - i - 1);
}

// step из меты тикера, если есть
function stepFromMeta(row) {
  const priceTick = row?.priceTick ?? row?.tickSize ?? row?.minPriceUnit;
  if (priceTick != null) return String(priceTick);
  const prec = row?.pricePrecision ?? row?.priceDecimals ?? row?.priceScale;
  if (Number.isFinite(Number(prec))) {
    const p = Number(prec);
    return p <= 0 ? "1" : `0.${"0".repeat(p - 1)}1`;
  }
  return null;
}

// fallback: из lastPrice
function stepFromLastPrice(lastPrice) {
  const d = decimalsOf(lastPrice);
  return d <= 0 ? "1" : `0.${"0".repeat(d - 1)}1`;
}

// поддержка форматов [[p,q], ...] и объектов
function normalizeSide(side) {
  if (!Array.isArray(side) || !side.length) return [];
  if (Array.isArray(side[0])) return side.map(([p, q]) => [String(p), String(q)]);
  return side.map((row) => {
    const p = row?.p ?? row?.price ?? row?.Price;
    const q = row?.q ?? row?.volume ?? row?.qty ?? row?.Volume;
    return [String(p), String(q)];
  });
}

function normalizeDepth(payload) {
  const data = payload?.data ?? payload?.result ?? payload;
  const asks = normalizeSide(data?.asks ?? data?.Asks ?? data?.sell);
  const bids = normalizeSide(data?.bids ?? data?.Bids ?? data?.buy);
  return { asks, bids };
}

export function useOurbitFutures(symbol, {
  pollIntervalMs = 1000,
  proxy = DEFAULT_PROXY,        // ✅ дефолт — через твой прокси
  depthLimit = 50,
} = {}) {
  const [orderBook, setOrderBook]     = useState({ asks: [], bids: [] });
  const [tickerData, setTickerData]   = useState(null);
  const [error, setError]             = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  const timerRef = useRef(null);
  const stepRef  = useRef(null);

  useEffect(() => {
    const sym = toOurbitFutSymbol(symbol);
    if (!sym) {
      setOrderBook({ asks: [], bids: [] });
      setTickerData(null);
      setIsConnected(false);
      setError(null);
      stepRef.current = null;
      return;
    }

    let cancelled = false;

    const fetchTickersAndStep = async () => {
      const url = viaProxy(proxy, FUT_TICKERS_URL);
      L("GET tickers:", url);
      const r = await fetch(url, { headers: { "ngrok-skip-browser-warning": "1" } });
      if (!r.ok) throw new Error(`Ourbit FUT tickers HTTP ${r.status}`);
      const js = await r.json();

      const arr = Array.isArray(js?.data) ? js.data : (Array.isArray(js?.result) ? js.result : []);
      if (!arr.length) throw new Error("Tickers empty");

      const row = arr.find((x) =>
        String(x?.symbol ?? x?.symbolDisplay ?? x?.instId ?? "").toUpperCase() === sym
      );
      if (!row) throw new Error(`Ticker for ${sym} not found`);

      const lp = row.lastPrice ?? row.last ?? row.price ?? row.close;
      if (lp != null) setTickerData({ lastPrice: String(lp) });

      const metaStep = stepFromMeta(row);
      stepRef.current = metaStep ?? stepFromLastPrice(lp);
      return stepRef.current;
    };

    const fetchDepthOnce = async () => {
      const step = stepRef.current || (await fetchTickersAndStep());
      const rawUrl = FUT_DEPTH_STEP_URL(sym, step);
      const finalUrl = viaProxy(proxy, rawUrl);

      L("GET depth_step:", finalUrl);
      const res = await fetch(finalUrl, { headers: { "ngrok-skip-browser-warning": "1" } });
      if (!res.ok) throw new Error(`Ourbit FUT depth HTTP ${res.status}`);
      const json = await res.json();

      const { asks, bids } = normalizeDepth(json);
      const A = depthLimit ? asks.slice(0, depthLimit) : asks;
      const B = depthLimit ? bids.slice(0, depthLimit) : bids;

      setOrderBook({ asks: A, bids: B });

      const a0 = A?.[0]?.[0] ? Number(A[0][0]) : null;
      const b0 = B?.[0]?.[0] ? Number(B[0][0]) : null;
      setTickerData((td) => ({
        ...td,
        ask: a0 != null ? String(a0) : td?.ask ?? null,
        bid: b0 != null ? String(b0) : td?.bid ?? null,
      }));

      setError(null);
      setIsConnected(true);
    };

    const start = async () => {
      try {
        await fetchTickersAndStep();
        await fetchDepthOnce();
      } catch (e) {
        L("init error", e?.message || e);
        setError(e?.message || String(e));
        setIsConnected(false);
      }
      if (cancelled) return;

      timerRef.current = setInterval(async () => {
        try { await fetchDepthOnce(); }
        catch (e) {
          L("poll error", e?.message || e);
          try { await fetchTickersAndStep(); } catch (e2) { L("re-ticker error", e2?.message || e2); }
          setIsConnected(false);
          setError(e?.message || String(e));
        }
      }, pollIntervalMs);
    };

    start();

    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = null;
      stepRef.current = null;
    };
  }, [symbol, pollIntervalMs, proxy, depthLimit]);

  return { isConnected, error, orderBook, tickerData };
}

export default useOurbitFutures;
